// extracted by mini-css-extract-plugin
export default {"invitesTable":"Invites_invitesTable__5U0dG","invitesTableEmptyMessage":"Invites_invitesTableEmptyMessage__V79-9"};